// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__29ZZT","fileBtn":"File_fileBtn__ztuK2","closeBtn":"File_closeBtn__1ISfm","fileSelected":"File_fileSelected__3cSFP","disabled":"File_disabled__2sJtz"};